import clsx from "clsx";

import EmptyBox from "../icons/empty-box.svg?react";

import styles from "./empty-state.module.css";
interface EmptyStateProps {
  heading: string;
  children?: React.ReactNode;
  className?: string;
}

function EmptyState({ heading, children, className = "" }: EmptyStateProps) {
  return (
    <div
      data-test-role="empty-state"
      className={clsx(styles.emptyState, className)}
    >
      <EmptyBox data-testid="empty-box-icon" />
      <div className={styles.messaging}>
        <div>{heading}</div>
        <div className={styles.helpText}>{children}</div>
      </div>
    </div>
  );
}

export default EmptyState;
